<script setup>
import NoData from '@/assets/images/common/no-data.svg'
import NoDataSearch from '@/assets/images/common/no-data-search.svg'

const props = defineProps({
  type: {
    type: String,
    default: 'common',
  },
  text: {
    type: String,
    default: '',
  },
})
const { t } = useI18n()
const raw = computed(() => ({
  common: { icon: NoData, label: t('暂无数据') },
  search: { icon: NoDataSearch, label: t('暂无搜索') },
}))
const cur = computed(() => raw.value[props.type])
</script>

<template>
  <div class="flex flex-col items-center justify-center pt-10">
    <slot name="icon">
      <component :is="cur.icon" class="w-24 h-24" :class="$attrs['icon-class']" />
    </slot>
    <slot>
      <span class="mt-2 text-sm font-medium text-textTertiary">{{ text || cur.label }}</span>
    </slot>
  </div>
</template>
